<template>
  <v-dialog
    width="30vw"
    :value="value"
    max-width="30vw"
    content-class="ims-standard-dialog"
    @input="$emit('input')"
  >
    <v-card class="ims-modal-card">
      <v-card-title class="headline ims-modal-header">
        Update Content for &nbsp;<strong> @{{ighandle}} </strong>
        <v-spacer></v-spacer>
        <v-btn
          icon
          text
          color="secondary"
          aria-label="Close update content dialog"
          @click="close()"
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <div class="pa-3">
        <div class="d-flex">
          <v-combobox
            class="mr-2"
            :items="pairedInfluencers"
            item-text="accountLabel"
            item-value="accountKey"
            return-object
            :loading="pairedInfluencersLoading"
            hide-details="auto"
            v-model="updateHandle"
            label="Handle"
            prefix="@"
            dense
            outlined
            @change="changePlatform"
          >
            <template v-slot:selection="{ item }">
              <span v-if="item.displayHandle || item.instagramHandle">
                {{item.displayHandle || item.instagramHandle}}
              </span>
              <span v-else>
                {{item}}
              </span>
            </template>
            <template v-slot:item="{ item }">
              <div class="d-flex align-center justify-space-between account-option">
                <social-handle-view
                  divClassName="d-inline"
                  :isTikTok="item.platform === 'tiktok'"
                  :isInstagram="!item.platform || item.platform === 'instagram'"
                  :isYoutube="item.platform === 'youtube'"
                  :isFacebook="item.platform === 'facebook'"
                  :isLinkedIn="item.platform === 'linkedin'"
                  :isTwitter="item.platform === 'twitter'"
                  :isXiaohongshu="item.platform === 'xiaohongshu'"
                  :tiktokHandle="item.instagramHandle"
                  :instagramHandle="item.instagramHandle"
                  :youtubeHandle="item.instagramHandle"
                  :facebookHandle="item.instagramHandle"
                  :linkedinHandle="item.instagramHandle"
                  :twitterHandle="item.twitterHandle || item.instagramHandle"
                  :xiaohongshuHandle="item.instagramHandle"
                  :isOthers="item.platform === 'others'"
                  :otherHandle="item.instagramHandle"
                />
                <span class="caption grey--text ml-3">{{ getPlatformDisplayName(item.platform) }}</span>
              </div>
            </template>
          </v-combobox>
          <v-select
            style="max-width: 200px;"
            v-model="updatePlatform"
            :items="platformTypes"
            label="Platform"
            outlined
            dense
            hide-details
          ></v-select>
        </div>
      </div>
      <div class="pa-3">
        <v-autocomplete
          v-model="country"
          :items="targetCountries"
          item-text="name"
          item-value="name"
          label="Country"
          outlined
          dense
          hide-details
        >
        </v-autocomplete>
      </div>
      <!-- <div class="pa-3">
        <v-select
          :items="postTypes"
          item-text="title"
          item-value="name"
          label="Content Type"
          v-model="postType"
          outlined
          hide-details
          dense
        ></v-select>
      </div> -->
      <div v-if="isStory" class="ims-modal-body update-insights-body">
        <v-card-text class="mt-4">
          <v-row>
            <v-col
              cols="12"
              md="12"
              xs="12"
            >
              <v-text-field
                label="Story Media URL"
                v-model="storyInsightSubmittingData.media_url"
                v-if="storyInsightSubmittingData.media_url"
              ></v-text-field>
              <v-text-field
                label="Story Media URL"
                v-model="storyInsightSubmittingData.embed_url"
                v-else
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col
              cols="12"
              md="12"
              xs="12"
            >
              <v-menu
                ref="datePicker"
                v-model="storyLiveCal"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    class="mt-3"
                    v-model="computedDateFormatted"
                    @blur="storyInsightSubmittingData.live_date = parseDate(storyInsightSubmittingData.live_date)"
                    append-icon="event"
                    readonly
                    outlined
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                  type="date"
                  v-model="storyInsightSubmittingData.live_date"
                  @input="storyLiveCal = false"
                ></v-date-picker>
              </v-menu>
            </v-col>
          </v-row>
          <v-row>
            <v-col
              cols="12"
              md="12"
              xs="12"
            >
              <v-btn
              color="secondary"
              small
              @click="openUploadStatsDialog('story')">
                Upload Stats with AI
              </v-btn>
              
            </v-col>
          </v-row>
          <v-row>
            <v-col
              cols="12"
              md="4"
            >
              <v-text-field
                v-model.number="storyInsightSubmittingData.insights.reach"
                label="Accounts reached"
                required
                type="number"
              ></v-text-field>
            </v-col>
            <v-col
              cols="12"
              md="4"
            >
              <v-text-field
                v-model.number="storyInsightSubmittingData.insights.impressions"
                label="Impressions"
                required
                type="number"
              ></v-text-field>
            </v-col>

            <v-col
              cols="12"
              md="4"
            >
              <v-text-field
                v-model.number="storyInsightSubmittingData.insights.story_likes"
                label="Story Likes"
                required
                type="number"
              ></v-text-field>
            </v-col>

          </v-row>
          <!-- <v-row>
            <v-col
              cols="12"
              md="4"
            >
              <v-text-field
                v-model.number="storyInsightSubmittingData.insights.exits"
                label="Exits"
                required
                type="number"
              ></v-text-field>
            </v-col>

            <v-col
              cols="12"
              md="4"
            >
              <v-text-field
                v-model.number="storyInsightSubmittingData.insights.taps_back"
                label="Taps Back"
                required
                type="number"
              ></v-text-field>
            </v-col>

            <v-col
              cols="12"
              md="4"
            >
              <v-text-field
                v-model.number="storyInsightSubmittingData.insights.taps_forward"
                label="Taps Forward"
                required
                type="number"
              ></v-text-field>
            </v-col>
          </v-row> -->
          <v-row>
            
            <v-col
              cols="12"
              md="4"
            >
              <v-text-field
                v-model.number="storyInsightSubmittingData.insights.replies"
                label="Replies"
                required
                type="number"
              ></v-text-field>
            </v-col>
            <v-col
              cols="12"
              md="4"
            >
              <v-text-field
                v-model.number="storyInsightSubmittingData.insights.shares"
                label="Shares"
                required
                type="number"
              ></v-text-field>
            </v-col>

            <v-col
              cols="12"
              md="4"
            >
              <v-text-field
                v-model.number="storyInsightSubmittingData.insights.link_clicks"
                label="Link Clicks"
                required
                type="number"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col
              cols="12"
              md="4"
            >
              <v-text-field
                v-model.number="storyInsightSubmittingData.insights.sticker_taps"
                label="Sticker Taps"
                required
                type="number"
              ></v-text-field>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-btn
            color="secondary"
            text
            @click="close()"
          >
            Cancel
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn
            color="secondary"
            text
            @click="saveInputtedInsights(storyInsightSubmittingData)"
          >
            Save
          </v-btn>
        </v-card-actions>
      </div>
      <div v-else-if="isTikTok" class="ims-modal-body update-insights-body">
        <v-card-text class="mt-4">
          <v-row>
            <v-col
              cols="12"
              md="12"
              xs="12"
            >
              <v-text-field
                label="Post URL"
                v-model.trim="postInsightSubmittingData.postURL"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col
              cols="12"
              md="12"
              xs="12"
            >
              <v-menu
                ref="datePicker"
                v-model="tiktokLiveCal"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    class="mt-3"
                    v-model="computedTikTokDateFormatted"
                    @blur="postInsightSubmittingData.live_date = parseDate(postInsightSubmittingData.live_date)"
                    append-icon="event"
                    readonly
                    outlined
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                  type="date"
                  v-model="postInsightSubmittingData.live_date"
                  @input="tiktokLiveCal = false"
                ></v-date-picker>
              </v-menu>
            </v-col>
          </v-row>
          <v-divider></v-divider>
          <h4>TikTok Insights</h4>
          <v-row>
            <v-col
              cols="12"
              md="12"
              xs="12"
            >
              <v-btn
              color="secondary"
              small
              @click="openUploadStatsDialog('tiktok')">
                Upload Stats with AI
              </v-btn>
              <v-btn
                class="ml-2"
                color="secondary"
                :disabled="isLoading || !getScrapeTargetLink()"
                @click="scrapComments(getScrapeTargetLink(), postInsightReportID)"
              >
                Extract Stats
                <v-icon right>mdi-refresh</v-icon>
              </v-btn>
            </v-col>
            
          </v-row>
          <v-row>
            <v-col
              cols="12"
              md="6"
            >
              <!-- <v-text-field
                v-model="postInsightSubmittingData.inputtedInsights.plays"
                label="Total Play Time"
                required
                type="text"
              ></v-text-field> -->
              <v-layout wrap>
                <v-flex xs12 md12 class="ma-0 pa-0" style="margin-top: -13px!important;margin-bottom:-45px!important">
                  <label style="font-weight: normal;font-size: 12px;color: rgba(0, 0, 0, 0.6);">Total Play Time</label>
                </v-flex>
              </v-layout>
              <v-layout wrap>
                <v-flex xs4 md4 lg4>
                  <v-text-field
                  v-model="totalPlayTime.hour"
                  label="h"
                  required
                  type="number"
                  min="0"
                ></v-text-field>
                </v-flex>
                <v-flex xs4 md4 lg4>
                  <v-text-field
                    v-model="totalPlayTime.minute"
                    label="m"
                    required
                    type="number"
                    min="0"
                  ></v-text-field>
                </v-flex>
                <v-flex xs4 md4 lg4>
                  <v-text-field
                    v-model="totalPlayTime.second"
                    label="s"
                    required
                    type="number"
                    min="0"
                  ></v-text-field>
                </v-flex>
              </v-layout>
            </v-col>
            <v-col
              cols="12"
              md="6"
            >
              <v-text-field
                v-model="postInsightSubmittingData.inputtedInsights.watches"
                label="Average Watch Time"
                required
                type="number"
              ></v-text-field>
            </v-col>
            <v-col
              cols="12"
              md="6"
            >
              <v-text-field
                v-model.number="postInsightSubmittingData.postInsights.like_count"
                label="Likes"
                required
                type="number"
              ></v-text-field>
            </v-col>
            <v-col
              cols="12"
              md="6"
            >
              <v-text-field
                v-model.number="postInsightSubmittingData.postInsights.comment_count"
                label="Comments"
                required
                type="number"
              ></v-text-field>
            </v-col>
            <v-col
              cols="12"
              md="6"
            >
              <v-text-field
                v-model.number="postInsightSubmittingData.postInsights.shares"
                label="Shares"
                type="number"
              ></v-text-field>
            </v-col>
            <v-col
              cols="12"
              md="6"
            >
              <v-text-field
                v-model.number="postInsightSubmittingData.inputtedInsights.saved"
                label="Favourites (Bookmarks)"
                type="number"
              ></v-text-field>
            </v-col>
            <v-col
              cols="12"
              md="6"
            >
              <v-text-field
                v-model.number="postInsightSubmittingData.postInsights.views"
                label="Plays (Views)"
                type="number"
              ></v-text-field>
            </v-col>
            <v-col
              cols="12"
              md="6"
            >
              <v-text-field
                v-model.number="postInsightSubmittingData.inputtedInsights.reach"
                label="Total Viewers (Reach)"
                type="number"
              ></v-text-field>
            </v-col>
            <v-col
              cols="12"
              md="6"
            >
              <v-text-field
                v-model.number="postInsightSubmittingData.inputtedInsights.watchedFullVideo"
                label="Watched full video (%)"
                type="number"
              ></v-text-field>
            </v-col>
            <v-col
              cols="12"
              md="6"
            >
              <v-text-field
                v-model.number="postInsightSubmittingData.inputtedInsights.photo_views"
                label="Photo Views"
                type="number"
              ></v-text-field>
            </v-col>
            <!-- <v-col
              cols="12"
              md="6"
            >
              <v-text-field
                v-model.number="postInsightSubmittingData.postInsights.outreach"
                label="Outreach"
                required
                type="number"
              ></v-text-field>
            </v-col>

            <v-col
              cols="12"
              md="6"
            >
              <v-text-field
                v-model.number="postInsightSubmittingData.postInsights.engagement_rate"
                label="Engagement Rate"
                required
                type="number"
              ></v-text-field>
            </v-col>
            <v-col
              cols="12"
              md="6"
            >
              <v-text-field
                v-model.number="postInsightSubmittingData.postInsights.views"
                label="Views"
                type="number"
              ></v-text-field>
            </v-col> -->
          </v-row>
          <!-- <v-divider></v-divider>
          <h4>Inputted Insights</h4>
          <v-row>
            <v-col
              cols="12"
              md="4"
            >
              <v-text-field
                v-model.number="postInsightSubmittingData.inputtedInsights.saved"
                label="Bookmarks"
                type="number"
              ></v-text-field>
            </v-col>
            <v-col
              cols="12"
              md="4"
            >
              <v-text-field
                v-model.number="postInsightSubmittingData.inputtedInsights.reach"
                label="Reach"
                type="number"
              ></v-text-field>
            </v-col>
            <v-col
              cols="12"
              md="4"
            >
              <v-text-field
                v-model.number="postInsightSubmittingData.inputtedInsights.impressions"
                label="Impressions"
                type="number"
              ></v-text-field>
            </v-col>
          </v-row> -->
        </v-card-text>
        <v-card-actions>
          <v-btn
            color="secondary"
            text
            @click="close()"
          >
            Cancel
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn
            color="secondary"
            text
            @click="saveInputtedInsights(postInsightSubmittingData)"
          >
            Save
          </v-btn>
        </v-card-actions>
      </div>

      <div v-else-if="isYoutube" class="ims-modal-body update-insights-body">
        <v-card-text class="mt-4">
          <v-row>
            <v-col
              cols="12"
              md="12"
              xs="12"
            >
              <v-text-field
                label="Post URL"
                v-model.trim="postInsightSubmittingData.postURL"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col
              cols="12"
              md="12"
              xs="12"
            >
              <v-menu
                ref="datePicker"
                v-model="youtubeLiveCal"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    class="mt-3"
                    v-model="computedYoutubeDateFormatted"
                    @blur="postInsightSubmittingData.live_date = parseDate(postInsightSubmittingData.live_date)"
                    append-icon="event"
                    readonly
                    outlined
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                  type="date"
                  v-model="postInsightSubmittingData.live_date"
                  @input="youtubeLiveCal = false"
                ></v-date-picker>
              </v-menu>
            </v-col>
          </v-row>
          <v-divider></v-divider>
          <h4>Youtube Insights</h4>
          <v-row>
            <v-col
              cols="12"
              md="12"
              xs="12"
            >
              <v-btn
                class="ml-2"
                color="secondary"
                :disabled="isLoading || !getScrapeTargetLink()"
                @click="scrapComments(getScrapeTargetLink(), postInsightReportID)"
              >
                Extract Stats
                <v-icon right>mdi-refresh</v-icon>
              </v-btn>
            </v-col>
            
          </v-row>
          <v-row>
            <v-col
              cols="12"
              md="6"
            >
              <v-text-field
                v-model.number="postInsightSubmittingData.postInsights.outreach"
                label="Outreach"
                required
                type="number"
              ></v-text-field>
            </v-col>

            <v-col
              cols="12"
              md="6"
            >
              <v-text-field
                v-model.number="postInsightSubmittingData.postInsights.engagement_rate"
                label="Engagement Rate"
                required
                type="number"
              ></v-text-field>
            </v-col>

            <v-col
              cols="12"
              md="6"
            >
              <v-text-field
                v-model.number="postInsightSubmittingData.postInsights.like_count"
                label="Likes"
                required
                type="number"
              ></v-text-field>
            </v-col>
            <v-col
              cols="12"
              md="6"
            >
              <v-text-field
                v-model.number="postInsightSubmittingData.postInsights.comment_count"
                label="Comments"
                required
                type="number"
              ></v-text-field>
            </v-col>
            <v-col
              cols="12"
              md="6"
            >
              <v-text-field
                v-model.number="postInsightSubmittingData.postInsights.views"
                label="Views"
                type="number"
              ></v-text-field>
            </v-col>
            <v-col
              cols="12"
              md="6"
            >
              <v-text-field
                v-model.number="postInsightSubmittingData.inputtedInsights.impressions"
                label="Impressions"
                type="number"
              ></v-text-field>
            </v-col>
            <v-col
              cols="12"
              md="6"
            >
              <v-text-field
                v-model.number="postInsightSubmittingData.inputtedInsights.unique_viewers"
                label="Unique Viewers"
                type="number"
              ></v-text-field>
            </v-col>
            <v-col
              cols="12"
              md="6"
            >
              <v-text-field
                v-model.number="postInsightSubmittingData.inputtedInsights.watches"
                label="Average Watch Time"
                type="number"
              ></v-text-field>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-btn
            color="secondary"
            text
            @click="close()"
          >
            Cancel
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn
            color="secondary"
            text
            @click="saveInputtedInsights(postInsightSubmittingData)"
          >
            Save
          </v-btn>
        </v-card-actions>
      </div>

      <div v-else-if="isXHS" class="ims-modal-body update-insights-body">
        <v-card-text class="mt-4">
          <v-row>
            <v-col
              cols="12"
              md="12"
              xs="12"
            >
              <v-text-field
                label="Media URL"
                v-model="xhsPostInsightSubmittingData.media_url"
                v-if="xhsPostInsightSubmittingData.media_url"
              ></v-text-field>
              <v-text-field
                label="Media URL"
                v-model="xhsPostInsightSubmittingData.embed_url"
                v-else
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col
              cols="12"
              md="12"
              xs="12"
            >
              <v-text-field
                label="XHS Link"
                v-model="xhsPostInsightSubmittingData.xhsLink"
                v-if="xhsPostInsightSubmittingData.xhsLink"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col
              cols="12"
              md="12"
              xs="12"
            >
              <v-text-field
                label="Full name"
                v-model="xhsPostInsightSubmittingData.xhsFullname"
                v-if="xhsPostInsightSubmittingData.xhsFullname"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col
              cols="12"
              md="12"
              xs="12"
            >
              <v-text-field
                type="number"
                label="Followers"
                v-model="xhsPostInsightSubmittingData.xhsFollowers"
                v-if="xhsPostInsightSubmittingData.xhsFollowers || xhsPostInsightSubmittingData.xhsFollowers === '0' || xhsPostInsightSubmittingData.xhsFollowers === 0"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col
              cols="12"
              md="12"
              xs="12"
            >
              <v-menu
                ref="datePicker"
                v-model="xhsLiveCal"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    class="mt-3"
                    v-model="computedXHSDateFormatted"
                    @blur="xhsPostInsightSubmittingData.live_date = parseDate(xhsPostInsightSubmittingData.live_date)"
                    append-icon="event"
                    readonly
                    outlined
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                  type="date"
                  v-model="xhsPostInsightSubmittingData.live_date"
                  @input="xhsLiveCal = false"
                ></v-date-picker>
              </v-menu>
            </v-col>
          </v-row>
          <v-row>
            <!-- <v-col
              cols="12"
              md="4"
            >
              <v-text-field
                v-model.number="xhsPostInsightSubmittingData.insights.outreach"
                label="Accounts reached"
                required
                type="number"
              ></v-text-field>
            </v-col> -->
            <v-col
              cols="12"
              md="4"
            >
              <v-text-field
                v-model.number="xhsPostInsightSubmittingData.insights.views"
                label="Views"
                required
                type="number"
              ></v-text-field>
            </v-col>
            <v-col
              cols="12"
              md="4"
            >
              <v-text-field
                v-model.number="xhsPostInsightSubmittingData.insights.watches"
                label="Average Watch Time"
                required
                type="number"
              ></v-text-field>
            </v-col>
            <v-col
              cols="12"
              md="4"
            >
              <v-text-field
                v-model.number="xhsPostInsightSubmittingData.insights.like_count"
                label="Likes"
                required
                type="number"
              ></v-text-field>
            </v-col>
          </v-row>
          <!-- <v-row>
            <v-col
              cols="12"
              md="4"
            >
              <v-text-field
                v-model.number="storyInsightSubmittingData.insights.exits"
                label="Exits"
                required
                type="number"
              ></v-text-field>
            </v-col>

            <v-col
              cols="12"
              md="4"
            >
              <v-text-field
                v-model.number="storyInsightSubmittingData.insights.taps_back"
                label="Taps Back"
                required
                type="number"
              ></v-text-field>
            </v-col>

            <v-col
              cols="12"
              md="4"
            >
              <v-text-field
                v-model.number="storyInsightSubmittingData.insights.taps_forward"
                label="Taps Forward"
                required
                type="number"
              ></v-text-field>
            </v-col>
          </v-row> -->
          <v-row>
            <v-col
              cols="12"
              md="4"
            >
              <v-text-field
                v-model.number="xhsPostInsightSubmittingData.insights.bookmarks"
                label="Saves"
                required
                type="number"
              ></v-text-field>
            </v-col>
            <v-col
              cols="12"
              md="4"
            >
              <v-text-field
                v-model.number="xhsPostInsightSubmittingData.insights.comment_count"
                label="Comments"
                required
                type="number"
              ></v-text-field>
            </v-col>
            <v-col
              cols="12"
              md="4"
            >
              <v-text-field
                v-model.number="xhsPostInsightSubmittingData.insights.shares"
                label="Shares"
                required
                type="number"
              ></v-text-field>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-btn
            color="secondary"
            text
            @click="close()"
          >
            Cancel
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn
            color="secondary"
            text
            @click="saveInputtedInsights(xhsPostInsightSubmittingData)"
          >
            Save
          </v-btn>
        </v-card-actions>
      </div>

      <div v-else-if="isLemon" class="ims-modal-body update-insights-body">
        <v-card-text class="mt-4">
          <v-row>
            <v-col
              cols="12"
              md="12"
              xs="12"
            >
              <v-text-field
                label="Media URL"
                v-model="lemonPostInsightSubmittingData.media_url"
                v-if="lemonPostInsightSubmittingData.media_url"
              ></v-text-field>
              <v-text-field
                label="Media URL"
                v-model="lemonPostInsightSubmittingData.embed_url"
                v-else
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col
              cols="12"
              md="12"
              xs="12"
            >
              <v-text-field
                label="lemon Link"
                v-model="lemonPostInsightSubmittingData.lemonLink"
                v-if="lemonPostInsightSubmittingData.lemonLink"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col
              cols="12"
              md="12"
              xs="12"
            >
              <v-text-field
                label="Full name"
                v-model="lemonPostInsightSubmittingData.lemonFullname"
                v-if="lemonPostInsightSubmittingData.lemonFullname"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col
              cols="12"
              md="12"
              xs="12"
            >
              <v-text-field
                type="number"
                label="Followers"
                v-model="lemonPostInsightSubmittingData.lemonFollowers"
                v-if="lemonPostInsightSubmittingData.lemonFollowers"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col
              cols="12"
              md="12"
              xs="12"
            >
              <v-menu
                ref="datePicker"
                v-model="lemonLiveCal"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    class="mt-3"
                    v-model="computedLemonDateFormatted"
                    @blur="lemonPostInsightSubmittingData.live_date = parseDate(lemonPostInsightSubmittingData.live_date)"
                    append-icon="event"
                    readonly
                    outlined
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                  type="date"
                  v-model="lemonPostInsightSubmittingData.live_date"
                  @input="lemonLiveCal = false"
                ></v-date-picker>
              </v-menu>
            </v-col>
          </v-row>
          <v-row>
            <!-- <v-col
              cols="12"
              md="4"
            >
              <v-text-field
                v-model.number="lemonPostInsightSubmittingData.insights.outreach"
                label="Accounts reached"
                required
                type="number"
              ></v-text-field>
            </v-col> -->
            <v-col
              cols="12"
              md="4"
            >
              <v-text-field
                v-model.number="lemonPostInsightSubmittingData.insights.views"
                label="Views"
                required
                type="number"
              ></v-text-field>
            </v-col>
            <v-col
              cols="12"
              md="4"
            >
              <v-text-field
                v-model.number="lemonPostInsightSubmittingData.insights.watches"
                label="Average Watch Time"
                required
                type="number"
              ></v-text-field>
            </v-col>
            <v-col
              cols="12"
              md="4"
            >
              <v-text-field
                v-model.number="lemonPostInsightSubmittingData.insights.like_count"
                label="Likes"
                required
                type="number"
              ></v-text-field>
            </v-col>
          </v-row>
          <!-- <v-row>
            <v-col
              cols="12"
              md="4"
            >
              <v-text-field
                v-model.number="storyInsightSubmittingData.insights.exits"
                label="Exits"
                required
                type="number"
              ></v-text-field>
            </v-col>

            <v-col
              cols="12"
              md="4"
            >
              <v-text-field
                v-model.number="storyInsightSubmittingData.insights.taps_back"
                label="Taps Back"
                required
                type="number"
              ></v-text-field>
            </v-col>

            <v-col
              cols="12"
              md="4"
            >
              <v-text-field
                v-model.number="storyInsightSubmittingData.insights.taps_forward"
                label="Taps Forward"
                required
                type="number"
              ></v-text-field>
            </v-col>
          </v-row> -->
          <v-row>
            <v-col
              cols="12"
              md="4"
            >
              <v-text-field
                v-model.number="lemonPostInsightSubmittingData.insights.bookmarks"
                label="Saves"
                required
                type="number"
              ></v-text-field>
            </v-col>
            <v-col
              cols="12"
              md="4"
            >
              <v-text-field
                v-model.number="lemonPostInsightSubmittingData.insights.comment_count"
                label="Comments"
                required
                type="number"
              ></v-text-field>
            </v-col>
            <v-col
              cols="12"
              md="4"
            >
              <v-text-field
                v-model.number="lemonPostInsightSubmittingData.insights.shares"
                label="Shares"
                required
                type="number"
              ></v-text-field>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-btn
            color="secondary"
            text
            @click="close()"
          >
            Cancel
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn
            color="secondary"
            text
            @click="saveInputtedInsights(lemonPostInsightSubmittingData)"
          >
            Save
          </v-btn>
        </v-card-actions>
      </div>

      <div v-else-if="isFacebook" class="ims-modal-body update-insights-body">
        <v-card-text class="mt-4">
          <v-row>
            <v-col
              cols="12"
              md="12"
              xs="12"
            >
              <v-text-field
                label="Post Media URL"
                v-model="fbPostInsightSubmittingData.media_url"
                v-if="fbPostInsightSubmittingData.media_url"
              ></v-text-field>
              <v-text-field
                label="Post Media URL"
                v-model="fbPostInsightSubmittingData.embed_url"
                v-else
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col
              cols="12"
              md="12"
              xs="12"
            >
              <v-menu
                ref="datePicker"
                v-model="fbLiveCal"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    class="mt-3"
                    v-model="computedFacebookDateFormatted"
                    @blur="fbPostInsightSubmittingData.live_date = parseDate(fbPostInsightSubmittingData.live_date)"
                    append-icon="event"
                    readonly
                    outlined
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                  type="date"
                  v-model="fbPostInsightSubmittingData.live_date"
                  @input="fbLiveCal = false"
                ></v-date-picker>
              </v-menu>
            </v-col>
          </v-row>
          <v-row>
            <v-col
              cols="12"
              md="4"
            >
              <v-text-field
                v-model.number="fbPostInsightSubmittingData.insights.outreach"
                label="Accounts reached"
                required
                type="number"
              ></v-text-field>
            </v-col>
            <v-col
              cols="12"
              md="4"
            >
              <v-text-field
                v-model.number="fbPostInsightSubmittingData.insights.like_count"
                label="Likes"
                required
                type="number"
              ></v-text-field>
            </v-col>

            <v-col
              cols="12"
              md="4"
            >
              <v-text-field
                v-model.number="fbPostInsightSubmittingData.insights.comment_count"
                label="Comments"
                required
                type="number"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col
              cols="12"
              md="4"
            >
              <v-text-field
                v-model.number="fbPostInsightSubmittingData.insights.views"
                label="Views"
                required
                type="number"
              ></v-text-field>
            </v-col>

            <v-col
              cols="12"
              md="4"
            >
              <v-text-field
                v-model.number="fbPostInsightSubmittingData.insights.shares"
                label="Shares"
                required
                type="number"
              ></v-text-field>
            </v-col>

            <v-col
              cols="12"
              md="4"
            >
              <v-text-field
                v-model.number="fbPostInsightSubmittingData.insights.bookmarks"
                label="Bookmarks"
                required
                type="number"
              ></v-text-field>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-btn
            color="secondary"
            text
            @click="close()"
          >
            Cancel
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn
            color="secondary"
            text
            @click="saveInputtedInsights(fbPostInsightSubmittingData)"
          >
            Save
          </v-btn>
        </v-card-actions>
      </div>

      <div v-else-if="isLinkedIn || isTwitter || isOthers" class="ims-modal-body update-insights-body">
        <v-card-text class="mt-4">
          <v-row>
            <v-col
              cols="12"
              md="12"
              xs="12"
            >
              <v-text-field
                label="Post URL"
                v-model="otherInsightSubmittingData.postURL"
                v-if="otherInsightSubmittingData.postURL"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row v-if="!isLinkedIn && !isTwitter">
            <v-col
              cols="12"
              md="12"
              xs="12"
            >
              <v-text-field
                label="Media URL"
                v-model="otherInsightSubmittingData.media_url"
                v-if="otherInsightSubmittingData.media_url"
              ></v-text-field>
              <v-text-field
                label="Media URL"
                v-model="otherInsightSubmittingData.embed_url"
                v-else
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row v-if="!isLinkedIn && !isTwitter">
            <v-col
              cols="12"
              md="12"
              xs="12"
            >
              <v-text-field
                label="Full name"
                v-model="otherInsightSubmittingData.othersFullname"
                v-if="otherInsightSubmittingData.othersFullname"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row v-if="!isLinkedIn && !isTwitter">
            <v-col
              v-if="!isTwitter"
              cols="12"
              md="12"
              xs="12"
            >
              <v-text-field
                type="number"
                label="Followers"
                v-model="otherInsightSubmittingData.othersFollowers"
                v-if="otherInsightSubmittingData.othersFollowers"
              ></v-text-field>
            </v-col>
          </v-row>

          <v-row>
            <v-col
              cols="12"
              md="12"
              xs="12"
            >
              <v-menu
                ref="datePicker"
                v-model="otherLiveCal"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    class="mt-3"
                    v-model="computedOthersDateFormatted"
                    @blur="otherInsightSubmittingData.live_date = parseDate(otherInsightSubmittingData.live_date)"
                    append-icon="event"
                    readonly
                    outlined
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                  type="date"
                  v-model="otherInsightSubmittingData.live_date"
                  @input="otherLiveCal = false"
                ></v-date-picker>
              </v-menu>
            </v-col>
          </v-row>

          <v-row v-if="!isLinkedIn">
            <!-- <v-col
              cols="12"
              md="4"
            >
              <v-text-field
                v-model.number="lemonPostInsightSubmittingData.insights.outreach"
                label="Accounts reached"
                required
                type="number"
              ></v-text-field>
            </v-col> -->
            <v-col
              v-if="!isTwitter"
              cols="12"
              md="4"
            >
              <v-layout wrap>
                <v-flex xs12 md12 class="ma-0 pa-0" style="margin-top: -3px!important;margin-bottom:-45px!important">
                  <label style="font-weight: normal;font-size: 12px;color: rgba(0, 0, 0, 0.6);">Total Play Time</label>
                </v-flex>
              </v-layout>
              <v-layout wrap>
                <v-flex xs4 md4 lg4>
                  <v-text-field
                  v-model="otherTotalPlayTime.hour"
                  label="h"
                  required
                  type="number"
                  min="0"
                ></v-text-field>
                </v-flex>
                <v-flex xs4 md4 lg4>
                  <v-text-field
                    v-model="otherTotalPlayTime.minute"
                    label="m"
                    required
                    type="number"
                    min="0"
                  ></v-text-field>
                </v-flex>
                <v-flex xs4 md4 lg4>
                  <v-text-field
                    v-model="otherTotalPlayTime.second"
                    label="s"
                    required
                    type="number"
                    min="0"
                  ></v-text-field>
                </v-flex>
              </v-layout>
            </v-col>
            <v-col
              v-if="!isTwitter"
              cols="12"
              md="4"
            >
              <v-text-field
                v-model.number="otherInsightSubmittingData.insights.views"
                label="Views"
                required
                type="number"
              ></v-text-field>
            </v-col>
            <v-col
              v-if="!isTwitter"
              cols="12"
              md="4"
            >
              <v-text-field
                v-model.number="otherInsightSubmittingData.insights.watches"
                label="Average Watch Time"
                required
                type="number"
              ></v-text-field>
            </v-col>
          </v-row>
          <!-- <v-row>
            <v-col
              cols="12"
              md="4"
            >
              <v-text-field
                v-model.number="storyInsightSubmittingData.insights.exits"
                label="Exits"
                required
                type="number"
              ></v-text-field>
            </v-col>

            <v-col
              cols="12"
              md="4"
            >
              <v-text-field
                v-model.number="storyInsightSubmittingData.insights.taps_back"
                label="Taps Back"
                required
                type="number"
              ></v-text-field>
            </v-col>

            <v-col
              cols="12"
              md="4"
            >
              <v-text-field
                v-model.number="storyInsightSubmittingData.insights.taps_forward"
                label="Taps Forward"
                required
                type="number"
              ></v-text-field>
            </v-col>
          </v-row> -->
          <v-row v-if="isTwitter">
            <v-col
              cols="12"
              md="4"
            >
              <v-text-field
                v-model.number="otherInsightSubmittingData.insights.impressions"
                label="Impressions"
                required
                type="number"
              ></v-text-field>
            </v-col>
            <v-col
              cols="12"
              md="4"
            >
              <v-text-field
                v-model.number="otherInsightSubmittingData.insights.comment_count"
                label="Replies"
                required
                type="number"
              ></v-text-field>
            </v-col>
            <v-col
              cols="12"
              md="4"
            >
              <v-text-field
                v-model.number="otherInsightSubmittingData.insights.like_count"
                label="Likes"
                required
                type="number"
              ></v-text-field>
            </v-col>
            <v-col
              cols="12"
              md="4"
            >
              <v-text-field
                v-model.number="otherInsightSubmittingData.insights.shares"
                label="Reposts"
                required
                type="number"
              ></v-text-field>
            </v-col>
            <v-col
              cols="12"
              md="4"
            >
              <v-text-field
                v-model.number="otherInsightSubmittingData.insights.saved"
                label="Bookmarks"
                required
                type="number"
              ></v-text-field>
            </v-col>
          </v-row>

          <v-row v-else-if="isLinkedIn">
            <v-col cols="12" class="pb-0">
              <div class="subtitle-1 font-weight-bold">Discovery</div>
            </v-col>
            <v-col cols="12" md="6">
              <v-text-field v-model.number="otherInsightSubmittingData.insights.impressions" label="Impressions" required type="number"></v-text-field>
            </v-col>
            <v-col cols="12" md="6">
              <v-text-field v-model.number="otherInsightSubmittingData.insights.reach" label="Members reached" required type="number"></v-text-field>
            </v-col>
            <v-col cols="12" md="6">
              <div class="subtitle-1 font-weight-bold mb-2">Video Performance</div>
              <v-text-field v-model.number="otherInsightSubmittingData.insights.video_views" label="Video views" required type="number"></v-text-field>
            </v-col>
            <v-col cols="12" md="6">
              <div class="subtitle-1 font-weight-bold mb-2">Profile Activity</div>
              <v-text-field v-model.number="otherInsightSubmittingData.insights.profile_viewers" label="Profile viewers from this post" required type="number"></v-text-field>
            </v-col>
            <v-col cols="12" class="pb-0">
              <div class="subtitle-1 font-weight-bold">Engagement</div>
            </v-col>
            <v-col cols="12" md="6">
              <v-text-field v-model.number="otherInsightSubmittingData.insights.like_count" label="Reactions" required type="number"></v-text-field>
            </v-col>
            <v-col cols="12" md="6">
              <v-text-field v-model.number="otherInsightSubmittingData.insights.comment_count" label="Comments" required type="number"></v-text-field>
            </v-col>
            <v-col cols="12" md="6">
              <v-text-field v-model.number="otherInsightSubmittingData.insights.shares" label="Reposts" required type="number"></v-text-field>
            </v-col>
            <v-col cols="12" md="6">
              <v-text-field v-model.number="otherInsightSubmittingData.insights.saved" label="Saves" required type="number"></v-text-field>
            </v-col>
          </v-row>

          <v-row v-else>
            <v-col cols="12" md="4">
              <v-text-field v-model.number="otherInsightSubmittingData.insights.saved" label="Saves" required type="number"></v-text-field>
            </v-col>
            <v-col cols="12" md="4">
              <v-text-field v-model.number="otherInsightSubmittingData.insights.comment_count" label="Comments" required type="number"></v-text-field>
            </v-col>
            <v-col cols="12" md="4">
              <v-text-field v-model.number="otherInsightSubmittingData.insights.shares" label="Shares" required type="number"></v-text-field>
            </v-col>
            <v-col cols="12" md="4">
              <v-text-field v-model.number="otherInsightSubmittingData.insights.like_count" label="Likes" required type="number"></v-text-field>
            </v-col>
          </v-row>
          
        </v-card-text>
        <v-card-actions>
          <v-btn
            color="secondary"
            text
            @click="close()"
          >
            Cancel
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn
            color="secondary"
            text
            @click="saveInputtedInsights(otherInsightSubmittingData)"
          >
            Save
          </v-btn>
        </v-card-actions>
      </div>


      <div v-else class="ims-modal-body update-insights-body">
        <v-card-text class="mt-4">
          <v-row>
            <v-col
              cols="12"
              md="12"
              xs="12"
            >
              <v-text-field
                label="Post URL"
                v-model.trim="postInsightSubmittingData.postURL"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col
              cols="12"
              md="12"
              xs="12"
            >
              <v-text-field
                label="Post Image URL"
                placeholder="Optional"
                v-model.trim="postInsightSubmittingData.postImageURL"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col
              cols="12"
              md="12"
              xs="12"
            >
              <v-menu
                ref="datePicker"
                v-model="postLiveCal"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    class="mt-3"
                    v-model="computedPostDateFormatted"
                    @blur="postInsightSubmittingData.live_date = parseDate(postInsightSubmittingData.live_date)"
                    append-icon="event"
                    readonly
                    outlined
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                  type="date"
                  v-model="postInsightSubmittingData.live_date"
                  @input="postLiveCal = false"
                ></v-date-picker>
              </v-menu>
            </v-col>
          </v-row>
          <!-- <v-divider></v-divider>
          <h4>Upload Stats</h4>
          <v-row>
            <v-col
              cols="12"
              md="12"
              xs="12"
            >
              <upload-media
              accept="*" 
              @change="mediaChanged" 
              :listMedia="media"
              :influencer="influencer"
              :campaign="campaignData"></upload-media>
            </v-col>
          </v-row> -->
          <v-divider></v-divider>
          <h4>Post Insights</h4>
          <v-row>
            <v-col
              cols="12"
              md="12"
              xs="12"
            >
              <v-btn
              color="secondary"
              @click="openUploadStatsDialog(isReel ? 'reel' : 'post')">
                Upload Stats with AI
              </v-btn>
              <v-btn
                class="ml-2"
                color="secondary"
                :disabled="isLoading || !getScrapeTargetLink()"
                @click="scrapComments(getScrapeTargetLink(), postInsightReportID)"
              >
                Extract Stats
                <v-icon right>mdi-refresh</v-icon>
              </v-btn>
            </v-col>
            
          </v-row>
          <v-row v-if="!isReel">
            <v-col
              cols="12"
              md="6"
            >
              <v-text-field
                v-model.number="postInsightSubmittingData.inputtedInsights.reach"
                label="Accounts Reached"
                type="number"
              ></v-text-field>
            </v-col>
            <v-col
              cols="12"
              md="6"
            >
              <v-text-field
                v-model.number="postInsightSubmittingData.inputtedInsights.impressions"
                label="Impressions"
                type="number"
              ></v-text-field>
            </v-col>
            <v-col
              cols="12"
              md="6"
            >
              <v-text-field
                v-model.number="postInsightSubmittingData.postInsights.like_count"
                label="Likes"
                required
                type="number"
              ></v-text-field>
            </v-col>
            <v-col
              cols="12"
              md="6"
            >
              <v-text-field
                v-model.number="postInsightSubmittingData.inputtedInsights.shares"
                label="Shares"
                type="number"
              ></v-text-field>
            </v-col>
            <v-col
              cols="12"
              md="6"
            >
              <v-text-field
                v-model.number="postInsightSubmittingData.postInsights.comment_count"
                label="Comments"
                required
                type="number"
              ></v-text-field>
            </v-col>
            <v-col
              cols="12"
              md="6"
            >
              <v-text-field
                v-model.number="postInsightSubmittingData.inputtedInsights.saved"
                label="Saves (Bookmarks)"
                type="number"
              ></v-text-field>
            </v-col>
          </v-row>
          <!-- <v-row>
            <v-col
              cols="12"
              md="6"
            >
              <v-text-field
                v-model.number="postInsightSubmittingData.postInsights.outreach"
                label="Outreach"
                required
                type="number"
              ></v-text-field>
            </v-col>

            <v-col
              cols="12"
              md="6"
            >
              <v-text-field
                v-model.number="postInsightSubmittingData.postInsights.engagement_rate"
                label="Engagement Rate"
                required
                type="number"
              ></v-text-field>
            </v-col>

            <v-col
              cols="12"
              md="6"
            >
              <v-text-field
                v-model.number="postInsightSubmittingData.postInsights.comment_count"
                label="Comments"
                required
                type="number"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-divider></v-divider>
          <h4>Inputted Insights</h4>
          <v-row>
            <v-col
              cols="12"
              md="4"
            >
              <v-text-field
                v-model.number="postInsightSubmittingData.inputtedInsights.saved"
                label="Bookmarks"
                type="number"
              ></v-text-field>
            </v-col>
            <v-col
              cols="12"
              md="4"
            >
              <v-text-field
                v-model.number="postInsightSubmittingData.inputtedInsights.shares"
                label="Shares"
                type="number"
              ></v-text-field>
            </v-col>
            <v-col
              cols="12"
              md="4"
            >
              <v-text-field
                v-model.number="postInsightSubmittingData.inputtedInsights.views"
                label="Views"
                type="number"
              ></v-text-field>
            </v-col>
          </v-row> -->
          <v-row v-if="isReel">
            <v-col
              cols="12"
              md="6"
            >
              <v-text-field
                v-model.number="postInsightSubmittingData.inputtedInsights.reach"
                label="Accounts Reached"
                type="number"
              ></v-text-field>
            </v-col>
            <v-col
              cols="12"
              md="6"
            >
              <v-text-field
                v-model.number="postInsightSubmittingData.inputtedInsights.views"
                label="Plays (Views)"
                type="number"
              ></v-text-field>
            </v-col>
            <v-col
              cols="12"
              md="6"
            >
              <v-text-field
                v-model.number="postInsightSubmittingData.postInsights.like_count"
                label="Likes"
                required
                type="number"
              ></v-text-field>
            </v-col>
            <v-col
              cols="12"
              md="6"
            >
              <v-text-field
                v-model.number="postInsightSubmittingData.inputtedInsights.saved"
                label="Saves (Bookmarks)"
                type="number"
              ></v-text-field>
            </v-col>
            <v-col
              cols="12"
              md="6"
            >
              <v-text-field
                v-model.number="postInsightSubmittingData.inputtedInsights.shares"
                label="Shares"
                required
                type="number"
              ></v-text-field>
            </v-col>
            <v-col
              cols="12"
              md="6"
            >
              <v-text-field
                v-model.number="postInsightSubmittingData.inputtedInsights.reposts"
                label="Reposts"
                required
                type="number"
              ></v-text-field>
            </v-col>
            <v-col
              cols="12"
              md="6"
            >
              <v-text-field
                v-model.number="postInsightSubmittingData.postInsights.comment_count"
                label="Comments"
                required
                type="number"
              ></v-text-field>
            </v-col>
            <v-col
              cols="12"
              md="6"
            >
              <v-layout wrap>
                <v-flex xs12 md12 class="ma-0 pa-0" style="margin-top: -3px!important;margin-bottom:-45px!important">
                  <label style="font-weight: normal;font-size: 12px;color: rgba(0, 0, 0, 0.6);">Watch Time</label>
                </v-flex>
              </v-layout>
              <v-layout wrap>
                <v-flex xs3 md3 lg3>
                  <v-text-field
                  v-model="reelTotalPlayTime.day"
                  label="d"
                  required
                  type="number"
                  min="0"
                ></v-text-field>
                </v-flex>
                <v-flex xs3 md3 lg3>
                  <v-text-field
                  v-model="reelTotalPlayTime.hour"
                  label="h"
                  required
                  type="number"
                  min="0"
                ></v-text-field>
                </v-flex>
                <v-flex xs3 md3 lg3>
                  <v-text-field
                    v-model="reelTotalPlayTime.minute"
                    label="m"
                    required
                    type="number"
                    min="0"
                  ></v-text-field>
                </v-flex>
                <v-flex xs3 md3 lg3>
                  <v-text-field
                    v-model="reelTotalPlayTime.second"
                    label="s"
                    required
                    type="number"
                    min="0"
                  ></v-text-field>
                </v-flex>
              </v-layout>
            </v-col>
            <v-col
              cols="12"
              md="6"
            >
              <v-text-field
                v-model="postInsightSubmittingData.inputtedInsights.watches"
                label="Average Watch Time"
                required
                type="number"
              ></v-text-field>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-btn
            color="secondary"
            text
            @click="close()"
          >
            Cancel
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn
            color="secondary"
            text
            @click="saveInputtedInsights(postInsightSubmittingData)"
          >
            Save
          </v-btn>
        </v-card-actions>
      </div>
    </v-card>
    <upload-stats-modal
    v-model="uploadStatsDialog"
    :value="uploadStatsDialog"
    :postType="aiPostType"
    :imagesToView="imagesToView"
    @statsConfirmed="confirmedStats"
    /> 
    <loading
      :active.sync="isLoading"
      :can-cancel="false"
      :is-full-page="true"
      loader="bars"
      background-color="#000"
      color="secondary"
      width.number="90"
      height.number="90"
    ></loading>
    
  </v-dialog>  
</template>
<script>
import campaignHelper from '@/components/views/Campaign/campaignHelper';
import { getReportPlatform } from '@/utils/reportPlatform'
import campaignAPIs from '../../views/Campaign/campaignAPIs';
import pairingAPIs from '../../views/Pairing/pairingAPIs';
import influencerAPIs from '../../views/Influencer/influencerAPIs';
import SocialHandleView from '@/components/scoped/custom/SocialHandleView'
import countries from '../../../../static/sources/countries';
import UploadMedia from '../post/UploadMedia';
import UploadStatsModal from './UploadStatsModal.vue';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import config from '@/config';

export default {
  name: 'UpdateInsights',
  components: {
    SocialHandleView,
    UploadMedia,
    UploadStatsModal,
    Loading
  },
  props: {
    post: Object,
    value: Boolean,
    campaign: Object,
    imagesToView: Object
  },
  data() {
    return {
      countries,
      isStory: false,
      isTikTok: false,
      isYoutube: false,
      isReel: false,
      isLemon: false,
      isOthers: false,
      isLinkedIn: false,
      isTwitter: false,
      storyLiveCal: false,
      postLiveCal: false,
      postData: null,
      tiktokLiveCal: false,
      youtubeLiveCal: false,
      fbLiveCal: false,
      xhsLiveCal: false,
      lemonLiveCal: false,
      uploadStatsDialog: false,
      postInsightReportID: '',
      ighandle: '',
      updateHandle: '',
      updatePlatform: '',
      platform: '',
      country: '',
      postTypes: campaignHelper.getDeliverableNames(),
      postType: '',
      mediaUrl: '',
      aiPostType: '',
      postInsightSubmittingData: {
        reportType: 'igPost',
        postURL: '',
        postImageURL: '',
        live_date: '',
        postInsights: {
          outreach: 0,
          engagement_rate: 0,
          like_count: 0,
          comment_count: 0
        },
        inputtedInsights: {
          saved: 0,
          shares: 0,
          reposts: 0,
          views: 0,
          reach: 0,
          impressions: 0,
          unique_viewers: 0,
          watches: 0,
          plays: 0,
          watchedFullVideo: 0
        }
      },
      storyInsightSubmittingData: {
        reportType: 'igStory',
        media_url: '',
        live_date: '',
        insights: {
          impressions: 0,
          story_likes: 0,
          reach: 0,
          replies: 0,
          exits: 0,
          taps_back: 0,
          taps_forward: 0,
          shares: 0,
          link_clicks: 0,
          sticker_taps: 0
        }
      },
      tikTokPostInsightSubmittingData: {
        reportType: 'tikTokPost',
        postURL: '',
        live_date: '',
        postInsights: {
          outreach: 0,
          engagement_rate: 0,
          like_count: 0,
          comment_count: 0
        },
        inputtedInsights: {
          saved: 0,
          shares: 0,
          views: 0,
          reach: 0,
          impressions: 0,
          watches: 0,
          plays: 0,
          watchedFullVideo: 0,
          photo_views: 0
        }
      },
      youtubePostInsightSubmittingData: {
        reportType: 'youtubePost',
        postURL: '',
        live_date: '',
        postInsights: {
          outreach: 0,
          engagement_rate: 0,
          like_count: 0,
          comment_count: 0,
          views: 0
        },
        inputtedInsights: {}
      },
      fbPostInsightSubmittingData: {
        reportType: 'fbPost',
        media_url: '',
        live_date: '',
        insights: {
          outreach: 0,
          like_count: 0,
          comment_count: 0,
          views: 0,
          shares: 0,
          bookmarks: 0
        },
        inputtedInsights: {}
      },
      xhsPostInsightSubmittingData: {
        reportType: 'xhsPost',
        media_url: '',
        xhsLink: '',
        xhsFullname: '',
        xhsFollowers: '',
        live_date: '',
        insights: {
          outreach: 0,
          like_count: 0,
          comment_count: 0,
          views: 0,
          watches: 0,
          shares: 0,
          bookmarks: 0
        },
        inputtedInsights: {}
      },
      lemonPostInsightSubmittingData: {
        reportType: 'lemonPost',
        media_url: '',
        lemonLink: '',
        lemonFullname: '',
        lemonFollowers: '',
        live_date: '',
        insights: {
          outreach: 0,
          like_count: 0,
          comment_count: 0,
          views: 0,
          watches: 0,
          shares: 0,
          bookmarks: 0
        },
        inputtedInsights: {}
      },
      otherInsightSubmittingData: {
        reportType: 'otherPost',
        postURL: '',
        media_url: '',
        live_date: '',
        othersFullname: '',
        othersFollowers: '',
        insights: {
          engagement_rate: '',
          outreach: '',
          like_count: '',
          comment_count: '',
          views: '',
          impressions: '',
          shares: '',
          reach: '',
          saved: '',
          watches: '',
          plays: '',
          video_views: '',
          profile_viewers: ''
        }
      },
      totalPlayTime: {
        hour: '',
        minute: '',
        second: ''
      },
      reelTotalPlayTime: {
        day: '',
        hour: '',
        minute: '',
        second: ''
      },
      otherTotalPlayTime: {
        hour: '',
        minute: '',
        second: ''
      },
      isLoading: false,
      scrapingStatusMessage: '',
      pairedInfluencers: [],
      pairedInfluencersLoading: false,
      platformTypes: ['Instagram', 'TikTok', 'Youtube', 'Facebook', 'LinkedIn', 'X (Twitter)', 'Xiaohongshu', 'Lemon8']
    }
  },
  computed: {
    computedDateFormatted () {
      return this.formatDate(this.storyInsightSubmittingData.live_date)
    },
    computedPostDateFormatted () {
      return this.formatDate(this.postInsightSubmittingData.live_date)
    },
    computedTikTokDateFormatted () {
      return this.formatDate(this.postInsightSubmittingData.live_date)
    },
    computedYoutubeDateFormatted () {
      return this.formatDate(this.postInsightSubmittingData.live_date)
    },
    computedXHSDateFormatted () {
      return this.formatDate(this.xhsPostInsightSubmittingData.live_date)
    },
    computedLemonDateFormatted () {
      return this.formatDate(this.lemonPostInsightSubmittingData.live_date)
    },
    computedFacebookDateFormatted () {
      return this.formatDate(this.fbPostInsightSubmittingData.live_date)
    },
    computedOthersDateFormatted () {
      return this.formatDate(this.otherInsightSubmittingData.live_date)
    }
  },
  methods: {
    close() {
      this.$emit('input');
      this.storyInsightSubmittingData = {
        reportType: 'igStory',
        media_url: '',
        live_date: '',
        insights: {
          impressions: 0,
          story_likes: 0,
          reach: 0,
          replies: 0,
          exits: 0,
          taps_back: 0,
          taps_forward: 0,
          shares: 0,
          link_clicks: 0,
          sticker_taps: 0
        }
      }
      this.postInsightSubmittingData = {
        reportType: 'igPost',
        inputtedInsights: {
          saved: 0,
          shares: 0,
          reposts: 0,
          views: 0,
          reach: 0,
          impressions: 0,
          unique_viewers: 0,
          watches: 0,
          plays: 0,
          watchedFullVideo: 0
        },
        postURL: '',
        postImageURL: '',
        live_date: '',
        postInsights: {
          outreach: 0,
          engagement_rate: 0,
          like_count: 0,
          comment_count: 0
        }
      }
      this.tikTokPostInsightSubmittingData = {
        reportType: 'tikTokPost',
        postURL: '',
        postInsights: {
          outreach: 0,
          engagement_rate: 0,
          like_count: 0,
          comment_count: 0,
          shares: 0,
          views: 0
        },
        inputtedInsights: {
          saved: 0,
          reach: 0,
          impressions: 0,
          watches: 0,
          plays: 0,
          photo_views: 0
        }
      }
      this.youtubePostInsightSubmittingData = {
        reportType: 'youtubePost',
        postURL: '',
        live_date: '',
        postInsights: {
          outreach: 0,
          engagement_rate: 0,
          like_count: 0,
          comment_count: 0,
          views: 0
        },
        inputtedInsights: {}
      }
      this.fbPostInsightSubmittingData = {
        reportType: 'fbPost',
        media_url: '',
        live_date: '',
        insights: {
          outreach: 0,
          like_count: 0,
          comment_count: 0,
          views: 0,
          shares: 0,
          bookmarks: 0
        },
        inputtedInsights: {}
      }
      this.xhsPostInsightSubmittingData = {
        reportType: 'xhsPost',
        media_url: '',
        xhsLink: '',
        xhsFullname: '',
        xhsFollowers: '',
        live_date: '',
        insights: {
          outreach: 0,
          like_count: 0,
          comment_count: 0,
          watches: 0,
          views: 0,
          shares: 0,
          bookmarks: 0
        },
        inputtedInsights: {}
      }
    },
    saveInputtedInsights(data) {
      if (this.postInsightReportID !== '') {
        data.updateAccountOnly = true
        if (this.updateHandle) {
          if (typeof this.updateHandle === 'object') {
            data.handle = this.updateHandle.displayHandle || this.updateHandle.instagramHandle
            data.platform = this.updatePlatform === 'X (Twitter)' ? 'twitter' : this.updatePlatform.toLowerCase()
          } else {
            data.handle = this.updateHandle
            data.platform = this.updatePlatform === 'X (Twitter)' ? 'twitter' : this.updatePlatform.toLowerCase()
          }
        }
        if (this.updateHandle === '' || this.updateHandle === null) {
          this.$swal({
            type: 'error',
            text: 'handle is required'
          })
          return
        }
        if (!this.country) {
          this.$swal({
            type: 'error',
            text: 'Country is required'
          })
          return
        }
        if (this.isStory) {
          if (!this.storyInsightSubmittingData.media_url && !this.storyInsightSubmittingData.embed_url) {
            this.$swal({
              type: 'error',
              text: 'Media URL is required'
            })
            return
          }
          if (!this.storyInsightSubmittingData.live_date) {
            this.$swal({
              type: 'error',
              text: 'Live Date is required'
            })
            return
          }
        }
        if (this.isTikTok || this.isYoutube || this.isPost) {
          if (!this.postInsightSubmittingData.postURL) {
            this.$swal({
              type: 'error',
              text: 'Post URL is required'
            })
            return
          }
          if (!this.postInsightSubmittingData.live_date) {
            this.$swal({
              type: 'error',
              text: 'Live Date is required'
            })
            return
          }
        }
        if (this.isXHS) {
          if (!this.xhsPostInsightSubmittingData.media_url && !this.xhsPostInsightSubmittingData.embed_url) {
            this.$swal({
              type: 'error',
              text: 'Media URL is required'
            })
            return
          }
          if (!this.xhsPostInsightSubmittingData.live_date) {
            this.$swal({
              type: 'error',
              text: 'Live Date is required'
            })
            return
          }
        }
        if (this.isLemon) {
          if (!this.lemonPostInsightSubmittingData.media_url && !this.lemonPostInsightSubmittingData.embed_url) {
            this.$swal({
              type: 'error',
              text: 'Media URL is required'
            })
            return
          }
          if (!this.lemonPostInsightSubmittingData.live_date) {
            this.$swal({
              type: 'error',
              text: 'Live Date is required'
            })
            return
          }
        }
        if (this.isLinkedIn || this.isTwitter || this.isOthers) {
          if (!this.isLinkedIn && !this.isTwitter && !this.otherInsightSubmittingData.media_url && !this.otherInsightSubmittingData.embed_url) {
            this.$swal({
              type: 'error',
              text: 'Media URL is required'
            })
            return
          }
          if (!this.otherInsightSubmittingData.postURL) {
            this.$swal({
              type: 'error',
              text: 'Post URL is required'
            })
            return
          }
          if (!this.otherInsightSubmittingData.live_date) {
            this.$swal({
              type: 'error',
              text: 'Live Date is required'
            })
            return
          }
        }
        if (this.isFacebook) {
          if (!this.fbPostInsightSubmittingData.media_url && !this.fbPostInsightSubmittingData.embed_url) {
            this.$swal({
              type: 'error',
              text: 'Media URL is required'
            })
            return
          }
          if (!this.fbPostInsightSubmittingData.live_date) {
            this.$swal({
              type: 'error',
              text: 'Live Date is required'
            })
            return
          }
        }
        // if (this.postType) {
        //   let matchType = this.postTypes.find(p => p.name === this.postType)
        //   if (matchType) {
        //     data.updateType = matchType
        //   }
        // }
        if (this.isTikTok) {
          data.inputtedInsights.plays = campaignHelper.formatTikTokPlayTime(this.totalPlayTime)
        }
        if (this.isReel) {
          data.inputtedInsights.plays = campaignHelper.formatReelPlayTime(this.reelTotalPlayTime)
        }
        if (this.isOthers) {
          data.insights.plays = campaignHelper.formatTikTokPlayTime(this.otherTotalPlayTime)
        }
        if (this.country) {
          data.country = this.country
        }
        if (this.mediaUrl) {
          data.mediaUrl = this.mediaUrl
        }
        campaignAPIs
          .updatePostInsights(this.postInsightReportID, data)
          .then(response => {
            this.$swal({
              title: 'Success',
              text: 'Saved Changes for this post',
              type: 'success'
            }).then(result => {
              this.$emit('done');
              this.close();
            })
          })
          .catch(error => {
            this.$swal({
              title: 'Error',
              text: 'Error in saving report',
              type: 'error'
            });
            console.log(error)
            this.close();
          })
      } else {
        console.log('ReportID empty')
      }
    },
    parseDate(date) {
      if (!date) return null;
      const [day, month, year] = date.split('/');
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
    },
    formatDate(date) {
      if (!date) return null;
      const [year, month, day] = date.split('-');
      let formattedDate = `${day}/${month}/${year}`
      if (formattedDate.includes('undefined')) {
        return date
      }
      return formattedDate;
    },
    clearTotalPlayTime() {
      this.totalPlayTime = {
        hour: '',
        minute: '',
        second: ''
      }
    },
    clearReelTotalPlayTime() {
      this.reelTotalPlayTime = {
        day: '',
        hour: '',
        minute: '',
        second: ''
      }
    },
    async fetchSelectedInfluencers(campaignId) {
      try {
        let resp = await pairingAPIs.getPairedInfluencersByCampaign(campaignId);
        const acceptedPairings = resp.filter(pairing => {
          const pairingStatus = pairing.pairing_details && pairing.pairing_details.status
          return Number(pairingStatus) === Number(config.pairingStatus.ACCEPTED)
        })
        const influencers = acceptedPairings.map(e => {
          let result = {}
          if (e.influencer_details) {
            let infDetails = e.influencer_details
            const rawInfluencerPlatform = String(infDetails.platform || 'instagram').toLowerCase()
            const influencerPlatform = rawInfluencerPlatform === 'x' ? 'twitter' : rawInfluencerPlatform
            const linkedinHandle = infDetails.linkedinHandle || (influencerPlatform === 'linkedin' ? (infDetails.userHandle || infDetails.instagramHandle) : '')
            const twitterHandle = infDetails.twitterHandle || (influencerPlatform === 'twitter' ? (infDetails.userHandle || infDetails.instagramHandle) : '')
            const displayHandle = influencerPlatform === 'linkedin'
              ? linkedinHandle
              : (influencerPlatform === 'twitter' ? twitterHandle : infDetails.instagramHandle)
            result = {
              pairingID: e.id,
              fullName: infDetails.fullname || infDetails.fullName,
              originalInstagramHandle: infDetails.instagramHandle,
              instagramHandle: displayHandle || infDetails.instagramHandle || twitterHandle || linkedinHandle || infDetails.fullname || infDetails.fullName,
              instagramAccountHandle: infDetails.igHandle || (influencerPlatform === 'instagram' ? infDetails.instagramHandle : ''),
              tiktokHandle: infDetails.tiktokHandle || (influencerPlatform === 'tiktok' ? (infDetails.userHandle || infDetails.instagramHandle) : ''),
              youtubeAccountHandle: infDetails.youtubeHandle || (influencerPlatform === 'youtube' ? (infDetails.userHandle || infDetails.instagramHandle) : ''),
              facebookAccountHandle: infDetails.facebookHandle || infDetails.fbHandle || (influencerPlatform === 'facebook' ? (infDetails.userHandle || infDetails.instagramHandle) : ''),
              linkedinHandle,
              twitterHandle,
              xhsHandle: infDetails.xhsHandle || (influencerPlatform === 'xiaohongshu' ? (infDetails.userHandle || infDetails.instagramHandle || infDetails.fullName) : ''),
              displayHandle: displayHandle || infDetails.instagramHandle || twitterHandle || linkedinHandle || infDetails.fullname || infDetails.fullName,
              platform: influencerPlatform,
              xhsID: infDetails.xhsID || '',
              instagramID: infDetails.instagramID,
              influencerID: infDetails.influencerID
            }
          }
          if (e.payout_details) {
            result.payoutStatus = e.payout_details.status
          }
          return result
        })
        this.pairedInfluencers = await this.expandPairedInfluencerHandles(influencers)
        const post = this.postData || {}
        const owner = (post.post_details && post.post_details.owner) || post.owner || {}
        const ownerHandle = post.profileHandle || post.profile_handle || owner.username || post.instagram
        const normalizedOwnerHandle = String(ownerHandle || '').replace(/^@+/, '').toLowerCase()
        const postPlatform = this.getPostAccountPlatform(post)
        const matchesOwnerHandle = influencer => {
          return normalizedOwnerHandle && String(influencer.displayHandle || influencer.instagramHandle || '').replace(/^@+/, '').toLowerCase() === normalizedOwnerHandle
        }
        const matchesPlatform = influencer => String(influencer.platform || 'instagram').toLowerCase() === postPlatform
        const selectedInfluencer = this.pairedInfluencers.find(influencer => matchesOwnerHandle(influencer) && matchesPlatform(influencer)) ||
          this.pairedInfluencers.find(influencer => !normalizedOwnerHandle && post.influencerID && influencer.influencerID === post.influencerID && matchesPlatform(influencer))
        if (selectedInfluencer) {
          this.updateHandle = selectedInfluencer
          this.changePlatform()
        } else if (ownerHandle) {
          this.updateHandle = ownerHandle
          this.updatePlatform = this.getPlatformDisplayName(postPlatform)
        }
        // this.xhsInfluencers = this.pairedInfluencers.filter(p => p.platform === 'xiaohongshu')
        // this.fbInfluencers = this.pairedInfluencers.filter(p => p.platform === 'facebook')
      } catch (error) {
        console.error(error);
      }
    },
    getInfluencerProfileHandles(profile, pairedInfluencer) {
      const nestedHandle = (key, handleKey) => profile && profile[key] && profile[key][handleKey]
      const accounts = [
        { platform: 'instagram', handle: profile.instagramHandle || nestedHandle('instagram', 'instagramHandle') || pairedInfluencer.instagramAccountHandle },
        { platform: 'tiktok', handle: profile.tiktokHandle || nestedHandle('tiktok', 'tiktokHandle') || pairedInfluencer.tiktokHandle },
        { platform: 'youtube', handle: profile.youtubeHandle || nestedHandle('youtube', 'youtubeHandle') || pairedInfluencer.youtubeAccountHandle },
        { platform: 'facebook', handle: profile.facebookHandle || profile.fbHandle || nestedHandle('facebook', 'facebookHandle') || nestedHandle('facebook', 'username') || pairedInfluencer.facebookAccountHandle },
        { platform: 'linkedin', handle: profile.linkedinHandle || nestedHandle('linkedin', 'linkedinHandle') || pairedInfluencer.linkedinHandle },
        { platform: 'twitter', handle: profile.twitterHandle || nestedHandle('twitter', 'twitterHandle') || pairedInfluencer.twitterHandle },
        { platform: 'xiaohongshu', handle: profile.xhsHandle || nestedHandle('xiaohongshu', 'xhsHandle') || pairedInfluencer.xhsHandle },
        { platform: 'lemon8', handle: profile.lemon8Handle || profile.lemonHandle }
      ]
      accounts.unshift({
        platform: pairedInfluencer.platform,
        handle: pairedInfluencer.displayHandle || pairedInfluencer.instagramHandle
      })

      const seen = new Set()
      return accounts.filter(account => {
        if (!account.handle) return false
        account.handle = String(account.handle).trim().replace(/^@+/, '')
        if (!account.handle) return false
        const key = `${account.platform}:${account.handle.toLowerCase()}`
        if (seen.has(key)) return false
        seen.add(key)
        return true
      })
    },
    createPairedHandleOption(pairedInfluencer, account, profileHandles) {
      const findHandle = platform => {
        const match = profileHandles.find(profileHandle => profileHandle.platform === platform)
        return match ? match.handle : ''
      }
      const accountOwner = pairedInfluencer.pairingID || pairedInfluencer.influencerID || 'unpaired'
      const normalizedPlatform = String(account.platform || 'others').toLowerCase()
      const normalizedHandle = String(account.handle || '').toLowerCase()
      return Object.assign({}, pairedInfluencer, {
        platform: account.platform,
        instagramHandle: account.handle,
        displayHandle: account.handle,
        accountKey: `${accountOwner}:${normalizedPlatform}:${normalizedHandle}`,
        accountLabel: `${account.handle} (${this.getPlatformDisplayName(normalizedPlatform)})`,
        originalInstagramHandle: findHandle('instagram') || pairedInfluencer.originalInstagramHandle,
        linkedinHandle: account.platform === 'linkedin' ? account.handle : findHandle('linkedin'),
        twitterHandle: account.platform === 'twitter' ? account.handle : findHandle('twitter')
      })
    },
    getPlatformDisplayName(platform) {
      const names = {
        instagram: 'Instagram',
        tiktok: 'TikTok',
        youtube: 'YouTube',
        facebook: 'Facebook',
        linkedin: 'LinkedIn',
        twitter: 'X (Twitter)',
        xiaohongshu: 'Xiaohongshu',
        lemon8: 'Lemon8',
        others: 'Other'
      }
      return names[String(platform || '').toLowerCase()] || platform
    },
    getPostAccountPlatform(post) {
      const owner = (post.post_details && post.post_details.owner) || post.owner || {}
      const platform = String(post.profilePlatform || post.profile_platform || owner.platform || post.platform || '').trim().toLowerCase()
      const normalizedPlatform = platform === 'x' ? 'twitter' : platform
      const accountPlatforms = ['instagram', 'tiktok', 'youtube', 'facebook', 'linkedin', 'twitter', 'xiaohongshu', 'lemon8', 'others']
      if (accountPlatforms.includes(normalizedPlatform)) return normalizedPlatform
      if (post.isTikTok) return 'tiktok'
      if (post.isYoutube) return 'youtube'
      if (post.isFacebook) return 'facebook'
      if (post.isXHS) return 'xiaohongshu'
      if (post.isLemon) return 'lemon8'
      const reportPlatform = getReportPlatform(post)
      if (reportPlatform === 'linkedin') return 'linkedin'
      if (reportPlatform === 'twitter') return 'twitter'
      return 'instagram'
    },
    getLatestInsightData(post) {
      const latestInsight = Array.isArray(post.insights) ? post.insights[post.insights.length - 1] : null
      const insightData = latestInsight && latestInsight.data ? latestInsight.data : (post.insights || {})
      return Object.assign({}, insightData, post.currentInsight || {}, post.inputtedInsights || {})
    },
    async expandPairedInfluencerHandles(influencers) {
      this.pairedInfluencersLoading = true
      try {
        const expandedGroups = await Promise.all(influencers.map(async pairedInfluencer => {
          let profile = {}
          if (pairedInfluencer.influencerID) {
            try {
              const response = await influencerAPIs.getInfluencer(pairedInfluencer.influencerID)
              profile = response && response.influencer ? response.influencer : response
            } catch (error) {
              console.error(`Unable to load connected accounts for influencer ${pairedInfluencer.influencerID}`, error)
            }
          }
          const profileHandles = this.getInfluencerProfileHandles(profile || {}, pairedInfluencer)
          if (!profileHandles.length) return [pairedInfluencer]
          return profileHandles.map(account => this.createPairedHandleOption(pairedInfluencer, account, profileHandles))
        }))
        const seen = new Set()
        return expandedGroups.reduce((options, group) => options.concat(group), []).filter(option => {
          const key = `${option.pairingID || option.influencerID}:${option.platform}:${String(option.displayHandle).toLowerCase()}`
          if (seen.has(key)) return false
          seen.add(key)
          return true
        })
      } finally {
        this.pairedInfluencersLoading = false
      }
    },
    async mediaChanged(media) {
      if (Array.isArray(media)) {
        if (media[0]) {
          this.mediaUrl = media[0].preview.src
        }
      }
    },
    openUploadStatsDialog(postType) {
      this.aiPostType = postType
      this.uploadStatsDialog = true
    },
    confirmedStats(statsData) {
      if (this.isPost || this.isTikTok) {
        if (statsData.new_followers) this.postInsightSubmittingData.inputtedInsights.reach = Number(statsData.new_followers)
        if (statsData.likes) this.postInsightSubmittingData.postInsights.like_count = Number(statsData.likes)
        if (statsData.comments) this.postInsightSubmittingData.postInsights.comment_count = Number(statsData.comments)
        if (statsData.bookmarks) this.postInsightSubmittingData.inputtedInsights.saved = Number(statsData.bookmarks)
      }
      if (this.isPost) {
        if (statsData.shares) this.postInsightSubmittingData.inputtedInsights.shares = Number(statsData.shares)
      }
      if (this.isTikTok) {
        if (statsData.total_play_time) {
          let playTimeParsed = this.parsePlayTime(statsData.total_play_time)
          if (playTimeParsed.length > 2) {
            this.totalPlayTime.hour = playTimeParsed[0]
            this.totalPlayTime.minute = playTimeParsed[1]
            this.totalPlayTime.second = playTimeParsed[2]
          }
        }
        if (statsData.average_watch_time_seconds) {
          this.postInsightSubmittingData.inputtedInsights.watches = statsData.average_watch_time_seconds
        }
        if (statsData.shares) this.postInsightSubmittingData.postInsights.shares = Number(statsData.shares)
        if (statsData.video_views) {
          this.postInsightSubmittingData.postInsights.views = statsData.video_views
        }
        if (statsData.watched_full_video_percentage) {
          this.postInsightSubmittingData.inputtedInsights.watchedFullVideo = statsData.watched_full_video_percentage
        }
      }
      if (this.isReel) {
        if (statsData.reposts != null) {
          this.postInsightSubmittingData.inputtedInsights.reposts = Number(statsData.reposts)
        }
        if (statsData.reached) {
          this.postInsightSubmittingData.inputtedInsights.reach = statsData.reached
        }
        if (statsData.video_views) {
          this.postInsightSubmittingData.inputtedInsights.views = statsData.video_views
        }
        if (statsData.reel_watch_time) {
          let playTimeParsed = this.parsePlayTime(statsData.reel_watch_time)
          if (playTimeParsed.length > 2) {
            this.reelTotalPlayTime.day = playTimeParsed[0]
            this.reelTotalPlayTime.hour = playTimeParsed[1]
            this.reelTotalPlayTime.minute = playTimeParsed[2]
            this.reelTotalPlayTime.second = playTimeParsed[3]
          }
        }
        if (statsData.average_watch_time_seconds) {
          this.postInsightSubmittingData.inputtedInsights.watches = statsData.average_watch_time_seconds
        }
      }
      if (this.isStory) {
        if (statsData.reached) {
          this.storyInsightSubmittingData.insights.reach = statsData.reached
        }
        if (statsData.replies) {
          this.storyInsightSubmittingData.insights.replies = statsData.replies
        }
        if (statsData.shares) {
          this.storyInsightSubmittingData.insights.shares = statsData.shares
        }
        if (statsData.link_clicks) {
          this.storyInsightSubmittingData.insights.link_clicks = statsData.link_clicks
        }
        if (statsData.sticker_taps) {
          this.storyInsightSubmittingData.insights.sticker_taps = statsData.sticker_taps
        }
      }
    },
    parsePlayTime(playTime) {
      const timeArray = [];
      let hours = 0
      let minutes = 0
      let seconds = 0
      // Split the playTime string into parts
      let currentNum = '';
      for (let i = 0; i < playTime.length; i++) {
        const char = playTime[i];
        // If the character is a digit, build the current number
        if (!isNaN(char)) {
          currentNum += char;
        } else {
          // If we reach a letter, we know we've completed a number
          if (currentNum) {
            if (char === 'h') {
              hours = parseInt(currentNum, 10);
            } else if (char === 'm') {
              minutes = parseInt(currentNum, 10);
            } else if (char === 's') {
              seconds = parseInt(currentNum, 10);
            }
            currentNum = ''; // Reset for the next number
          }
        }
      }
      // Push the results into the array
      timeArray.push(hours, minutes, seconds);
      return timeArray;
    },
    changePlatform() {
      if (this.updateHandle && this.updateHandle.platform) {
        const platform = String(this.updateHandle.platform).toLowerCase();
        if (platform === 'tiktok') {
          this.updatePlatform = 'TikTok'
        } else if (platform === 'linkedin') {
          this.updatePlatform = 'LinkedIn'
        } else if (platform === 'twitter' || platform === 'x') {
          this.updatePlatform = 'X (Twitter)'
        } else if (platform === 'youtube') {
          this.updatePlatform = 'Youtube'
        } else if (platform === 'xiaohongshu') {
          this.updatePlatform = 'Xiaohongshu'
        } else if (platform === 'lemon8') {
          this.updatePlatform = 'Lemon8'
        } else {
          this.updatePlatform = platform.charAt(0).toUpperCase() + platform.slice(1);
        }
      }
    },
    logScrapingStatus(message) {
      this.scrapingStatusMessage = message;
      console.log(`[UpdateInsightsModal][STATUS] ${message}`);
    },
    getScrapeTargetLink() {
      if (this.isTikTok || this.isYoutube || this.isPost) {
        return this.postInsightSubmittingData.postURL;
      }
      if (this.isLinkedIn || this.isTwitter || this.isOthers) {
        return this.otherInsightSubmittingData.postURL;
      }
      const post = this.post || {}
      if (this.isXHS) {
        return this.xhsPostInsightSubmittingData.xhsLink || (post.post_details ? post.post_details.link : '');
      }
      if (this.isLemon) {
        return this.lemonPostInsightSubmittingData.lemonLink || (post.post_details ? post.post_details.link : '');
      }
      return (post.post_details ? post.post_details.link : '') || post.link || '';
    },
    async scrapComments(link, postID) {
      if (!link || !postID) {
        this.$swal({ title: 'Info', text: 'A post link and report ID are required for extraction.', type: 'info' });
        return false;
      }
      const platform = (this.isTikTok ? 'tiktok' : this.isYoutube ? 'youtube' : (this.isPost || this.isReel) ? 'instagram' : null);
      if (!platform) {
        this.$swal({ title: 'Info', text: 'Only Instagram posts/reels, TikTok, and YouTube support public extraction.', type: 'info' });
        return false;
      }
      this.isLoading = true;
      try {
        const result = await campaignAPIs.extractReportPost(link, platform);
        const target = this.postInsightSubmittingData;
        for (const key of ['like_count', 'comment_count', 'shares', 'saved', 'views']) {
          const value = result.insights && result.insights[key];
          if (typeof value !== 'number' || !Number.isFinite(value) || value < 0) continue;
          const manualField = key === 'saved' || (key === 'shares' && platform === 'instagram') || (key === 'views' && this.isReel);
          this.$set(manualField ? target.inputtedInsights : target.postInsights, key, value);
        }
        this.logScrapingStatus('Public metrics extracted. Review them before saving.');
        return true;
      } catch (error) {
        this.$swal({ title: 'Error', text: (error.response && error.response.data && error.response.data.message) || error.message || 'Failed to extract public metrics.', type: 'error' });
        return false;
      } finally {
        this.isLoading = false;
      }
    }
  },
  mounted() {
    // imple mounted here
  },
  watch: {
    post(newPost) {
      if (!newPost) {
        this.postData = null
        this.postInsightReportID = ''
        return
      }
      this.postData = newPost
      this.postInsightReportID = newPost.id
      this.isStory = false
      this.isTikTok = false
      this.isYoutube = false
      this.isReel = false
      this.isPost = false
      this.isXHS = false
      this.isFacebook = false
      this.isLemon = false
      this.isOthers = false
      this.isLinkedIn = false
      this.isTwitter = false
      this.updateHandle = ''
      this.updatePlatform = ''
      this.postType = ''
      this.country = ''
      this.mediaUrl = ''
      this.fetchSelectedInfluencers(newPost.campaignID)
      this.clearTotalPlayTime()
      this.clearReelTotalPlayTime()
      this.targetCountries = Object.assign([], this.countries)
      if (newPost.postType) this.postType = newPost.postType
      if (newPost.instagram) this.updateHandle = newPost.instagram
      if (newPost.country) {
        this.country = newPost.country
      } else {
        this.country = this.targetCountries[0].name
      }
      if (this.campaign && this.campaign.targetLocation) {
        if (Array.isArray(this.campaign.targetLocation)) {
          this.targetCountries = this.targetCountries.filter(t => this.campaign.targetLocation.includes(t.code))
        }
      }
      if (newPost.isStory || newPost.isMultipleContents) { // Updating Story Insights
        this.isStory = true
        this.platform = 'instagram'
        this.updatePlatform = this.getPlatformDisplayName(this.getPostAccountPlatform(newPost))
        this.ighandle = newPost.owner.username
        if (newPost.isMultipleContents) {
          this.storyInsightSubmittingData.embed_url = newPost.embed_url
        } else {
          this.storyInsightSubmittingData.media_url = newPost.media_url
        }
        this.storyInsightSubmittingData.live_date = this.parseDate(newPost.live_date) || ''
        if (newPost.insights) {
          this.storyInsightSubmittingData.insights.impressions = newPost.insights.impressions
          this.storyInsightSubmittingData.insights.story_likes = newPost.insights.story_likes
          this.storyInsightSubmittingData.insights.reach = newPost.insights.reach
          this.storyInsightSubmittingData.insights.replies = newPost.insights.replies
          this.storyInsightSubmittingData.insights.exits = newPost.insights.exits
          this.storyInsightSubmittingData.insights.taps_back = newPost.insights.taps_back
          this.storyInsightSubmittingData.insights.taps_forward = newPost.insights.taps_forward
          this.storyInsightSubmittingData.insights.shares = newPost.insights.shares || 0
          this.storyInsightSubmittingData.insights.link_clicks = newPost.insights.link_clicks
          this.storyInsightSubmittingData.insights.sticker_taps = newPost.insights.sticker_taps
        }
      } else if (newPost.isTikTok) { // Updating Tik Tok Insights
        this.isStory = false
        this.isTikTok = true
        this.isYoutube = false
        this.isLemon = false
        this.isPost = false
        this.isOthers = false
        this.platform = 'tiktok'
        this.updatePlatform = this.getPlatformDisplayName(this.getPostAccountPlatform(newPost))
        this.ighandle = newPost.owner.username
        this.postInsightSubmittingData.reportType = 'tikTokPost'
        this.postInsightSubmittingData.live_date = this.parseDate(newPost.live_date) || ''
        if (newPost.post_details) {
          this.postInsightSubmittingData.postURL = newPost.post_details.link
        }
        if (newPost.inputtedInsights) {
          this.postInsightSubmittingData.inputtedInsights.saved = newPost.inputtedInsights.saved
          this.postInsightSubmittingData.postInsights['shares'] = newPost.inputtedInsights.shares || 0
          this.postInsightSubmittingData.postInsights['views'] = newPost.inputtedInsights.views || 0
          this.postInsightSubmittingData.inputtedInsights.reach = newPost.inputtedInsights.reach || 0
          this.postInsightSubmittingData.inputtedInsights.impressions = newPost.inputtedInsights.impressions || 0
          this.postInsightSubmittingData.inputtedInsights.watchedFullVideo = newPost.inputtedInsights.watchedFullVideo || ''
          this.postInsightSubmittingData.inputtedInsights.photo_views = newPost.inputtedInsights.photo_views || 0
          this.postInsightSubmittingData.inputtedInsights.watches = newPost.inputtedInsights.watches ? campaignHelper.formatWatchTime(newPost.inputtedInsights.watches) : 0
          this.totalPlayTime = newPost.inputtedInsights.plays ? campaignHelper.parseTikTokPlayTime(newPost.inputtedInsights.plays) : this.totalPlayTime
        }
        if (newPost.currentInsight) {
          this.postInsightSubmittingData.postInsights['engagement_rate'] = newPost.currentInsight.engagement_rate
          this.postInsightSubmittingData.postInsights['outreach'] = newPost.currentInsight.outreach
          this.postInsightSubmittingData.postInsights['like_count'] = newPost.currentInsight.like_count
          this.postInsightSubmittingData.postInsights['comment_count'] = newPost.currentInsight.comment_count
          if (this.postInsightSubmittingData.postInsights['shares'] === 0) {
            this.postInsightSubmittingData.postInsights['shares'] = newPost.currentInsight.shares || 0
          }
          if (this.postInsightSubmittingData.postInsights['views'] === 0) {
            this.postInsightSubmittingData.postInsights['views'] = newPost.currentInsight.views || 0
          }
        }
      } else if (newPost.isYoutube) { // Updating Youtube Insights
        this.isStory = false
        this.isTikTok = false
        this.isYoutube = true
        this.isLemon = false
        this.isPost = false
        this.isOthers = false
        this.platform = 'youtube'
        this.updatePlatform = 'Youtube'
        this.ighandle = newPost.owner.username
        this.postInsightSubmittingData.reportType = 'youtubePost'
        this.postInsightSubmittingData.live_date = this.parseDate(newPost.live_date) || ''
        if (newPost.post_details) {
          this.postInsightSubmittingData.postURL = newPost.post_details.link
        }
        if (newPost.inputtedInsights) {
          this.postInsightSubmittingData.inputtedInsights.impressions = newPost.inputtedInsights.impressions || 0
          this.postInsightSubmittingData.inputtedInsights.unique_viewers = newPost.inputtedInsights.unique_viewers || 0
          this.postInsightSubmittingData.inputtedInsights.watches = newPost.inputtedInsights.watches || 0
        }
        if (newPost.currentInsight) {
          this.postInsightSubmittingData.postInsights['engagement_rate'] = newPost.currentInsight.engagement_rate
          this.postInsightSubmittingData.postInsights['outreach'] = newPost.currentInsight.outreach
          this.postInsightSubmittingData.postInsights['like_count'] = newPost.currentInsight.like_count
          this.postInsightSubmittingData.postInsights['comment_count'] = newPost.currentInsight.comment_count
          this.postInsightSubmittingData.postInsights['views'] = newPost.currentInsight.views || 0
        }
      } else if (newPost.isFacebook) { // Updating Youtube Insights
        this.isStory = false
        this.isTikTok = false
        this.isYoutube = false
        this.isXHS = false
        this.isLemon = false
        this.isPost = false
        this.isOthers = false
        this.isFacebook = true
        this.platform = 'facebook'
        this.updatePlatform = 'Facebook'
        this.ighandle = newPost.owner.username
        this.fbPostInsightSubmittingData.reportType = 'facebookPost'
        this.fbPostInsightSubmittingData.live_date = this.parseDate(newPost.live_date) || ''
        this.fbPostInsightSubmittingData.media_url = newPost.media_url
        if (newPost.insights) {
          this.fbPostInsightSubmittingData.insights.outreach = newPost.insights.outreach
          this.fbPostInsightSubmittingData.insights.like_count = newPost.insights.like_count
          this.fbPostInsightSubmittingData.insights.comment_count = newPost.insights.comment_count
          this.fbPostInsightSubmittingData.insights.views = newPost.insights.views
          this.fbPostInsightSubmittingData.insights.shares = newPost.insights.shares
          this.fbPostInsightSubmittingData.insights.bookmarks = newPost.insights.bookmarks
        }
      } else if (newPost.isXHS) { // Updating Youtube Insights
        this.isStory = false
        this.isTikTok = false
        this.isYoutube = false
        this.isFacebook = false
        this.isLemon = false
        this.isPost = false
        this.isOthers = false
        this.isXHS = true
        this.platform = 'xiaohongshu'
        this.updatePlatform = 'Xiaohongshu'
        this.ighandle = newPost.owner.username
        this.xhsPostInsightSubmittingData.reportType = 'xhsPost'
        this.xhsPostInsightSubmittingData.live_date = this.parseDate(newPost.live_date) || ''
        this.xhsPostInsightSubmittingData.embed_url = newPost.embed_url || ''
        this.xhsPostInsightSubmittingData.xhsLink = newPost.xhsLink
        this.xhsPostInsightSubmittingData.xhsFullname = newPost.owner.fullName
        this.xhsPostInsightSubmittingData.xhsFollowers = newPost.owner.followers
        if (newPost.insights) {
          this.xhsPostInsightSubmittingData.insights.outreach = newPost.insights.outreach
          this.xhsPostInsightSubmittingData.insights.like_count = newPost.insights.like_count
          this.xhsPostInsightSubmittingData.insights.comment_count = newPost.insights.comment_count
          this.xhsPostInsightSubmittingData.insights.views = newPost.insights.views
          this.xhsPostInsightSubmittingData.insights.watches = newPost.insights.watches
          this.xhsPostInsightSubmittingData.insights.shares = newPost.insights.shares
          this.xhsPostInsightSubmittingData.insights.bookmarks = newPost.insights.bookmarks
        }
      } else if (newPost.isLemon) { // Updating Youtube Insights
        this.isStory = false
        this.isTikTok = false
        this.isYoutube = false
        this.isFacebook = false
        this.isXHS = false
        this.isPost = false
        this.isOthers = false
        this.isLemon = true
        this.platform = 'lemon8'
        this.updatePlatform = 'Lemon8'
        this.ighandle = newPost.owner.username
        this.lemonPostInsightSubmittingData.reportType = 'lemonPost'
        this.lemonPostInsightSubmittingData.live_date = this.parseDate(newPost.live_date) || ''
        this.lemonPostInsightSubmittingData.embed_url = newPost.embed_url || ''
        this.lemonPostInsightSubmittingData.lemonLink = newPost.lemonLink
        this.lemonPostInsightSubmittingData.lemonFullname = newPost.owner.fullName
        this.lemonPostInsightSubmittingData.lemonFollowers = newPost.owner.followers
        if (newPost.insights) {
          this.lemonPostInsightSubmittingData.insights.outreach = newPost.insights.outreach
          this.lemonPostInsightSubmittingData.insights.like_count = newPost.insights.like_count
          this.lemonPostInsightSubmittingData.insights.comment_count = newPost.insights.comment_count
          this.lemonPostInsightSubmittingData.insights.views = newPost.insights.views
          this.lemonPostInsightSubmittingData.insights.watches = newPost.insights.watches
          this.lemonPostInsightSubmittingData.insights.shares = newPost.insights.shares
          this.lemonPostInsightSubmittingData.insights.bookmarks = newPost.insights.bookmarks
        }
      } else if (['linkedin', 'twitter'].includes(getReportPlatform(newPost)) || newPost.isOthers) {
        this.isStory = false
        this.isTikTok = false
        this.isYoutube = false
        this.isFacebook = false
        this.isXHS = false
        this.isPost = false
        this.isLemon = false
        const reportPlatform = getReportPlatform(newPost)
        this.isLinkedIn = reportPlatform === 'linkedin'
        this.isTwitter = reportPlatform === 'twitter'
        this.isOthers = reportPlatform === 'others' || (!this.isLinkedIn && !this.isTwitter)
        this.platform = newPost.platform || 'others'
        this.updatePlatform = this.isLinkedIn ? 'LinkedIn' : (this.isTwitter ? 'X (Twitter)' : 'Others')
        this.ighandle = newPost.owner.username
        this.otherInsightSubmittingData.reportType = 'otherPost'
        this.otherInsightSubmittingData.live_date = this.parseDate(newPost.live_date) || ''
        const postUrl = newPost.postLink || newPost.postURL || newPost.post_details || ''
        this.otherInsightSubmittingData.postURL = typeof postUrl === 'string'
          ? postUrl
          : (postUrl.link || postUrl.url || postUrl.href || '')
        this.otherInsightSubmittingData.embed_url = newPost.embed_url || ''
        this.otherInsightSubmittingData.othersFullname = newPost.owner.fullName
        this.otherInsightSubmittingData.othersFollowers = newPost.owner.followers
        const insights = this.getLatestInsightData(newPost)
        if (Object.keys(insights).length) {
          this.otherInsightSubmittingData.insights.outreach = insights.outreach
          this.otherInsightSubmittingData.insights.like_count = insights.like_count
          this.otherInsightSubmittingData.insights.comment_count = insights.comment_count
          this.otherInsightSubmittingData.insights.views = insights.views
          this.otherInsightSubmittingData.insights.impressions = insights.impressions != null
            ? insights.impressions
            : (this.isTwitter ? insights.views : '')
          this.otherInsightSubmittingData.insights.reach = insights.reach != null
            ? insights.reach
            : insights.outreach
          this.otherInsightSubmittingData.insights.watches = insights.watches
          this.otherInsightSubmittingData.insights.shares = insights.shares
          this.otherInsightSubmittingData.insights.saved = insights.saved
          this.otherInsightSubmittingData.insights.plays = insights.plays
          this.otherInsightSubmittingData.insights.video_views = insights.video_views
          this.otherInsightSubmittingData.insights.profile_viewers = insights.profile_viewers
          this.otherInsightSubmittingData.insights.engagement_rate = insights.engagement_rate
          this.otherTotalPlayTime = insights.plays ? campaignHelper.parseTikTokPlayTime(insights.plays) : this.otherTotalPlayTime
        }
      } else { // Updating Post Insights
        this.isStory = false
        this.isTikTok = false
        this.isYoutube = false
        this.isFacebook = false
        this.isXHS = false
        this.isLemon = false
        this.isOthers = false
        this.isPost = true
        this.platform = 'instagram'
        this.updatePlatform = this.getPlatformDisplayName(this.getPostAccountPlatform(newPost))
        this.updateHandle = newPost.profileHandle || newPost.profile_handle || (newPost.post_details && newPost.post_details.owner && newPost.post_details.owner.username) || newPost.instagram || ''
        this.postInsightSubmittingData.live_date = this.parseDate(newPost.live_date) || ''
        if (newPost.post_details) {
          this.ighandle = newPost.post_details.owner.username
          this.postInsightSubmittingData.postURL = newPost.post_details.link
          this.postInsightSubmittingData.postImageURL = newPost.post_details.image || ''
        }
        if (newPost.inputtedInsights) {
          this.postInsightSubmittingData.inputtedInsights.saved = newPost.inputtedInsights.saved
          this.postInsightSubmittingData.inputtedInsights.shares = newPost.inputtedInsights.shares
          this.postInsightSubmittingData.inputtedInsights.reposts = newPost.inputtedInsights.reposts || 0
          this.postInsightSubmittingData.inputtedInsights.views = newPost.inputtedInsights.views || 0
          this.postInsightSubmittingData.inputtedInsights.reach = newPost.inputtedInsights.reach || 0
          this.postInsightSubmittingData.inputtedInsights.impressions = newPost.inputtedInsights.impressions || 0
          this.postInsightSubmittingData.inputtedInsights.watches = newPost.inputtedInsights.watches || 0
          if (newPost.postType === 'IGR') {
            this.isReel = true
            this.reelTotalPlayTime = newPost.inputtedInsights.plays ? campaignHelper.parseReelPlayTime(newPost.inputtedInsights.plays) : this.reelTotalPlayTime
          }
        }
        if (newPost.currentInsight) {
          this.postInsightSubmittingData.postInsights['engagement_rate'] = newPost.currentInsight.engagement_rate
          this.postInsightSubmittingData.postInsights['outreach'] = newPost.currentInsight.outreach
          this.postInsightSubmittingData.postInsights['like_count'] = newPost.currentInsight.like_count
          this.postInsightSubmittingData.postInsights['comment_count'] = newPost.currentInsight.comment_count
        }
      }
    }
  }
}
</script>

<style scoped>
.account-option {
  width: 100%;
}

.update-insights-body {
  display: flex;
  flex-direction: column;
  min-height: 0;
  overflow-y: auto;
  overflow-x: hidden;
}

.update-insights-body > .v-card-text {
  flex: 0 0 auto;
}

.update-insights-body > .v-card-actions {
  position: sticky;
  bottom: 0;
  z-index: 3;
  flex: 0 0 auto;
  background: var(--ims-color-surface, #f4f4f4);
  border-top: 1px solid var(--ims-color-border, #dedede);
}
</style>



// WEBPACK FOOTER //
// UpdateInsightsModal.vue?a1fd8e3c